import React from "react";
import {toJS} from 'mobx';
import {observer} from 'mobx-react';
import {withRouter} from 'react-router';

import board_cast from '@common/BoardCast';
import ListTable from '@components/ListTable/ListTable.jsx';
import TurnToCharge_store, {filter_store, pagination_store} from '@store/Statistic/TurnToCharge/TurnToChargeStore';

@withRouter
@observer
class TurnToChargeListTable extends React.Component {

    constructor(props) {
        super();
    }

    componentWillReceiveProps(props, nextProps) {

    }

    columns = [
        {
            key: 'id',
            sorter: true,
            title: '交易号',
            dataIndex: 'id'
        },
        {
            key: 'nick_name',
            sorter: true,
            title: '手机号',
            dataIndex: 'nick_name',
        },
        {
            key: 'pet_name',
            sorter: true,
            title: '昵称',
            dataIndex: 'pet_name'
        },
        {
            key: 'time',
            sorter: true,
            title: '转充时间',
            dataIndex: 'time'
        },
        {
            key: 'in_money',
            sorter: true,
            title: '转充金额',
            dataIndex: 'in_money'
        },
        {
            key: 'donation_amount',
            sorter: true,
            title: '赠送金额',
            dataIndex: 'donation_amount'
        },
        {
            key: 'description',
            sorter: true,
            title: '转充说明',
            dataIndex: 'description'
        },
    ]

    componentDidMount() {
        TurnToCharge_store.reloadDatas();
        board_cast.on('closeAllExpanded', this.closeAllExpandedForReload);
    }

    componentWillUnmount() {
        filter_store.resetAttr();
    }

    /**
     * 分页器点击回调
     */

    pagination_callback(page, size, order_by) {

        TurnToCharge_store.searchByFilter({
            page: page,
            page_size: size,
            ...order_by,
        })
    }

    render() {
        return (
            <ListTable
                data_source={toJS(TurnToCharge_store.item_array)}
                columns={this.columns}
                pagination={
                    {
                        // 当前页
                        current: pagination_store.page_cur,
                        // 每页条数
                        pageSize: pagination_store.page_size,
                        // 总数据条数
                        total: pagination_store.data_total,
                        // 页码候选列表
                        pageSizeOptions: pagination_store.page_size_options,
                    }
                }
                onChange={
                    (pagination, filters, sorter) => {
                        let current = pagination.current;
                        let page_size = pagination.pageSize;

                        let order_by = undefined;
                        if (sorter.columnKey !== undefined) {
                            let desc = 0;
                            if (sorter.order == 'descend') {
                                desc = 1;
                            }
                            order_by = {
                                order: sorter.columnKey,
                                desc: desc
                            }
                        }

                        this.pagination_callback(current, page_size, order_by);
                    }
                }
            />
        )
    }
}

export default TurnToChargeListTable;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Statistic/TurnToCharge/TurnToChargeListTable.jsx